let classicVideo, classicTab, rushTab, rushVideo

document.addEventListener('DOMContentLoaded', function () {
  setTimeout(() => {
    initClassic()
    initRush()

    document.getElementById('btnBettingBack')?.addEventListener('click', function () {
      classicVideo.mute()
      rushVideo.mute()
    })
  }, 1000)
})

function initClassic() {
  const config = buildConfig(
    document.getElementById('classicDealerVideo')?.getAttribute('attr-stream-name'),
    false,
  )

  classicVideo = new NanoPlayer('classicDealerVideo')
  classicVideo.setup(config).then(
    function (config) {},
    function (error) {
      alert(error.message)
    },
  )

  classicTab = document.getElementById('tab-classic')

  classicTab.addEventListener('click', function () {
    classicVideo.unmute()
    rushVideo.mute()
  })
}

function initRush() {
  const config = buildConfig(
    document.getElementById('rushDealerVideo')?.getAttribute('attr-stream-name'),
    true,
  )

  rushVideo = new NanoPlayer('rushDealerVideo')
  rushVideo.setup(config).then(
    function (config) {},
    function (error) {
      alert(error.message)
    },
  )

  rushTab = document.getElementById('tab-rush')

  rushTab.addEventListener('click', function () {
    rushVideo.unmute()
    classicVideo.mute()
  })
}

function buildConfig(streamname, muted) {
  return {
    source: {
      defaults: {
        service: 'bintu',
      },
      entries: [
        {
          index: 0,
          h5live: {
            rtmp: {
              streamname,
            },
          },
        },
      ],
    },
    playback: {
      autoplay: true,
      automute: true,
      muted,
    },
  }
}
